import { useNavigate } from "react-router-dom";
import { clearTypeTreeCache } from "../services/typeTreeCache";

export const createAuthFetch = (navigate) => {
  return async (url, options = {}) => {
    const token = localStorage.getItem("token");

    const mergedOptions = {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
        ...(options.headers || {}),
      },
      ...options,
    };

    const response = await fetch(url, mergedOptions);

    if (response.status === 401) {
      clearTypeTreeCache();
      localStorage.removeItem("token");
      navigate("/login");
      window.location.reload();
      return null;
    }

    return response;
  };
};

const authFetch = createAuthFetch();
export default authFetch;
